import AreaChart from './AreaChart'
import LineChart, { DataEntry } from './LineChart'
import { Tooltip } from './components'

const Chart = {
  AreaChart,
  LineChart,
  Tooltip,
}

export type { DataEntry }
export default Chart
